// https://holastanley.zendesk.com/api/v2/brands/
import { Brands } from "./Config";

export async function getTicketInfo(id) {
	let ticketJson;
	await fetch(`https://holastanley.zendesk.com/api/v2/tickets/${id}.json`, {
		method: "GET",
		headers: {
			Authorization:
				"Bearer c37245862ac78f98fd1b5ba50a6cd7d3c954aa81a10ebb35b8bc7f8a23c756c3",
			"Content-Type": "application/json",
			Accept: "application/json",
		},
	})
		.then((res) => {
			return res.json();
		})
		.then((res) => {
			ticketJson = res;
		})
		.catch((error) => console.error("Error: ", error));
	return ticketJson;
}

export async function getUserInfo(id) {
	let userJson;
	await fetch(`https://holastanley.zendesk.com/api/v2/users/${id}.json`, {
		method: "GET",
		headers: {
			Authorization:
				"Bearer c37245862ac78f98fd1b5ba50a6cd7d3c954aa81a10ebb35b8bc7f8a23c756c3",
			"Content-Type": "application/json",
			Accept: "application/json",
		},
	})
		.then((res) => res.json())
		.then((res) => (userJson = res))
		.catch((error) => console.error("Error: ", error));
	return userJson;
}

export async function getGroup(id) {
	let groupJson;
	await fetch(`https://holastanley.zendesk.com/api/v2/groups/${id}.json`, {
		method: "GET",
		headers: {
			Authorization:
				"Bearer c37245862ac78f98fd1b5ba50a6cd7d3c954aa81a10ebb35b8bc7f8a23c756c3",
			"Content-Type": "application/json",
			Accept: "application/json",
		},
	})
		.then((res) => {
			return res.json();
		})
		.then((res) => {
			groupJson = res;
		})
		.catch((error) => console.error("Error: ", error));
	return groupJson;
}

function getBigBrand(brandName) {
	brandName = brandName.toLowerCase();
	if (brandName.includes("black and decker") || brandName.includes("bd") || brandName.includes("black+decker") || brandName.includes("black + decker")) {
		return Brands.BLACK_AND_DECKER;
	}
	if (brandName.includes("dewalt")) {
		return Brands.DEWALT;
	}
	if (brandName.includes("irwin")) {
		return Brands.IRWIN;
	}
	if (brandName.includes("craftsman")) {
		return Brands.CRAFTSMAN;
	}
	if (brandName.includes("bostitch")) {
		return Brands.BOSTITCH;
	}
	if (brandName.includes("lenox")) {
		return Brands.LENOX;
	}
	if (brandName.includes("porter cable")) {
		return Brands.PORTER_CABLE;
	}
	return Brands.STANLEY;
}

export async function getBrandName(id) {
	let brand;
	await fetch(`https://holastanley.zendesk.com/api/v2/brands/${id}.json`, {
		method: "GET",
		headers: {
			Authorization:
				"Bearer c37245862ac78f98fd1b5ba50a6cd7d3c954aa81a10ebb35b8bc7f8a23c756c3",
			"Content-Type": "application/json",
			Accept: "application/json",
		},
	})
		.then((res) => {
			return res.json();
		})
		.then((res) => {
			brand = res.brand.name;
		})
		.catch((error) => console.error("Error: ", error));
	return getBigBrand(brand);
}
